import React from 'react';
import { useTranslation } from 'react-i18next';
import './ExpertiseSectionHome.css';

interface ExpertiseSectionProps {
  translationKey?: string;
  defaultText?: string;
  translationNamespace?: string;
}

const ExpertiseSection: React.FC<ExpertiseSectionProps> = ({ 
  translationKey,
  defaultText,
  translationNamespace = 'home'
}) => {
  const { t } = useTranslation();

  const defaultHomeText = "IT Monkeys réunit des professionnels qualifiés, spécialisés dans les technologies de pointe. Nous assurons une mise en œuvre fluide et efficace, conforme aux plus hauts standards de qualité et de performance.";

  const getText = () => {
    if (translationKey) {
      return t(`${translationNamespace}.${translationKey}`, defaultText || defaultHomeText);
    }
    return defaultText || defaultHomeText;
  };

  return (
    <div className="expertise-section">
      <div className="main-text">
        <h3 className="h3-gradient">
          {getText()}
        </h3>
      </div>
    </div>
  );
};

export default ExpertiseSection;
